import { ExpensablePolicyFragment } from 'generated/resources/graphql'

import { SpendingPolicyData } from 'modules/expenses/graphql/types'

export const buildEvaluatePolicyData = (policyEvaluation: ExpensablePolicyFragment | undefined) => {
  if (policyEvaluation) {
    const data: SpendingPolicyData[] = []

    if (policyEvaluation.result === 'out_of_policy') {
      policyEvaluation.failedRules.forEach((failedRule) => {
        const ruleGroup = policyEvaluation.applicableRuleGroups.find(
          (applicableRuleGroup) => failedRule.applicableRuleGroupId === applicableRuleGroup.id
        )

        const policy = policyEvaluation.spendingPolicies.find(
          (spendingPolicy) => failedRule.applicablePolicyId === spendingPolicy.id
        )

        const rules = ruleGroup?.spendingPolicyRules
        const parentRules = ruleGroup?.parentRuleGroup?.spendingPolicyRules

        const subcategoryRule = rules?.find((x) => x.identifier === 'subcategory')
        const categoryRule = subcategoryRule
          ? parentRules?.find((x) => x.identifier === 'category')
          : rules?.find((x) => x.identifier === 'category')

        const amountRule = rules?.find((x) => x.identifier === 'amount')
        const currencyRule = rules?.find((x) => x.identifier === 'currency')
        const timeframeRule = rules?.find((x) => x.identifier === 'time_frame')

        const spentAmount = failedRule.failedRules?.find(
          (x) => x.identifier === 'amount'
        )?.resourceValue

        const policyData: SpendingPolicyData = {
          name: policy?.name,
          amount: amountRule,
          currency: currencyRule,
          category: categoryRule,
          subcategory: subcategoryRule,
          timeframe: timeframeRule,
          spentAmount,
          result: policyEvaluation?.result,
        }

        data.push(policyData)
      })
    } else if (policyEvaluation.result === 'within_policy') {
      const ruleGroup = policyEvaluation.applicableRuleGroups[0]

      const policy = policyEvaluation.spendingPolicies[0]

      const rules = ruleGroup?.spendingPolicyRules
      const parentRules = ruleGroup?.parentRuleGroup?.spendingPolicyRules

      const subcategoryRule = rules?.find((x) => x.identifier === 'subcategory')
      const categoryRule = subcategoryRule
        ? parentRules?.find((x) => x.identifier === 'category')
        : rules?.find((x) => x.identifier === 'category')

      const amountRule = rules?.find((x) => x.identifier === 'amount')
      const currencyRule = rules?.find((x) => x.identifier === 'currency')
      const timeframeRule = rules?.find((x) => x.identifier === 'time_frame')

      const spentAmount = undefined

      const policyData: SpendingPolicyData = {
        name: policy?.name,
        amount: amountRule,
        currency: currencyRule,
        category: categoryRule,
        subcategory: subcategoryRule,
        timeframe: timeframeRule,
        spentAmount,
        result: policyEvaluation?.result,
      }

      data.push(policyData)
    }

    return {
      result: policyEvaluation.result,
      policiesData: data,
    }
  }
}
